import { useStore } from '@nanostores/solid'
import { eventEndDate } from '~/config'
import { useTimestamp } from '~/resources/timestamp'
import { $debugForceEnded } from '~/store/debug-force-ended'

/** Pure derivation: the clock the event UI runs on. With the QA force-ended
 *  toggle on, time is pinned just past the event end so every consumer (day
 *  cards, top-nav countdown, rail auto-jump) flips to its ended state through
 *  the same code path real users hit — no faked data, only faked time. */
export function deriveEffectiveNow(
  now: Date,
  endDate: Date,
  forceEnded: boolean,
): Date {
  if (!forceEnded) return now
  return new Date(Math.max(now.getTime(), endDate.getTime() + 1))
}

export function useEffectiveNow() {
  const ts = useTimestamp()
  const forceEnded = useStore($debugForceEnded)
  return () => deriveEffectiveNow(ts(), eventEndDate, forceEnded())
}

export function useEventEnded() {
  const now = useEffectiveNow()
  return () => now().getTime() > eventEndDate.getTime()
}
